module.exports = {"230605001":"红岗街道","230605004":"八百垧街道","230605005":"杏南街道","230605006":"解放街道","230605007":"创业街道","230605100":"杏树岗镇","230605480":"红岗区铁人生态工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230605.json
// module id = 677
// module chunks = 0